import store from '@store';
const autoGeneratedListingContentPayload = ({ values, content_type }) => {
  return {
    content_type: content_type,
    purpose_name: values?.listing_purpose?.title
      ? values?.listing_purpose?.title
      : values?.purpose === 1
        ? 'Sale'
        : 'Rent',
    type: values?.property_type_label,
    city: values?.['location-info']?.city?.title?.en,
    ...(values?.furnished && { furnished: values?.furnished == '1' ? 'yes' : 'no' }),
    rental_frequency: values?.purpose === 2 && values?.rental_frequency,
    price:
      values?.purpose === 2
        ? values?.rental_price
          ? parseInt(values?.rental_price)
          : 0
        : values?.price
          ? parseInt(values?.price)
          : 0,
    beds: parseInt(values?.bedrooms) || null,
    baths: parseInt(values?.bathrooms) || null,
  };
};

const findFeatureById = (arr, featureId) => {
  for (const group of arr) {
    const feature = group.features.find((feature) => feature.feature_id == featureId);
    if (feature) {
      return feature?.id;
    }
  }
  return null;
};

const getListingFeatures = (featuresAmenities, listingFeatures = []) =>
  featuresAmenities && Object.keys(featuresAmenities)?.length
    ? Object.keys(featuresAmenities)
        .map((e) =>
          !!findFeatureById(listingFeatures, e)
            ? {
                id: findFeatureById(listingFeatures, e),
                feature_id: e,
                ...(featuresAmenities?.[e] == undefined || featuresAmenities?.[e] == false
                  ? { _destroy: true }
                  : { feature_value: featuresAmenities?.[e] === true ? 'Yes' : featuresAmenities?.[e] }),
              }
            : featuresAmenities?.[e]
              ? { feature_id: e, feature_value: featuresAmenities?.[e] === true ? 'Yes' : featuresAmenities?.[e] }
              : null,
        )
        .filter((e) => !!e)
    : [];

const getUpdateListingPayload = ({ userId, values, listing, autoRenew, source, creditsInfo }) => {
  const user = store.getState().app.loginUser.user;
  const isSellOrRentProperty =
    values?.listing_purpose?.slug == 'sale' ||
    values?.listing_purpose?.slug == 'rent' ||
    values?.purpose == 1 ||
    values?.purpose == 2;
  const images = values.property_images?.length
    ? values.property_images
        .filter((e) => e.uuid)
        .map((image) => {
          const { id, uuid, isMainImage, _destroy, order } = image;
          return {
            name: uuid,
            is_main_image: !!isMainImage,
            order: order,
            // TODO: need to fix this
            ...(id && typeof id === 'number' && { id }),
            _destroy,
          };
        })
    : [];
  const mainImageIndex = images.findIndex((e) => !!e.is_main_image);
  if (mainImageIndex != -1) {
    const mainImage = images.splice(mainImageIndex, 1);
    images.unshift(mainImage?.[0]);
  } else {
    const index = images.findIndex((e) => !e?._destroy);
    images[index] = { ...images[index], is_main_image: true };
  }
  const platformDetails = {};
  user?.platforms.forEach((e) => {
    platformDetails[`posted_on_${e?.slug}`] = 1;
  });
  return {
    listing: {
      source,
      purpose_id: values?.purpose,
      type_id: values?.property_type,
      latitude: values?.['location-info']?.map?.latitude || values?.latitude || values?.location?.latitude,
      longitude: values?.['location-info']?.map?.longitude || values?.longitude || values?.location?.longitude,
      ...(isSellOrRentProperty && {
        is_furnished: values?.furnished == '1',
      }),

      area_unit_id: 1,

      area_unit_value: values?.area,
      ...(values?.residence_type_applicable && { residence_type: values?.residence_type }),
      listing_features_attributes: values?.id
        ? getListingFeatures(values?.feature_and_amenities, listing?.listing_features)
        : Object.keys(values?.feature_and_amenities || {})
            .filter((e) => !!values.feature_and_amenities[e])
            .map((e) => ({
              feature_id: e,
              feature_value:
                values.feature_and_amenities[e] === true ? 'Yes' : values.feature_and_amenities[e].toString(),
            })),
      beds: values?.bedrooms,
      bath: values?.bathrooms,
      price: values?.listing_purpose?.slug == 'sale' || values?.purpose == 1 ? values?.price : values?.rental_price,
      ...(values?.listing_purpose?.slug == 'rent' || (values?.purpose == 2 && { rental_price: values?.rental_price })),
      listing_images_attributes: images?.length ? images.map((image, index) => ({ ...image, order: index })) : [],
      title: values?.property_title_en,
      title_l1: values?.property_title_ar,
      description: values?.property_description_en,
      description_l1: values?.property_description_ar,
      platform_id: 1,
      ...(isSellOrRentProperty && {
        rent_frequency_id: values?.rental_frequency,
      }),
      is_autorenewal_on: autoRenew,
      location_id: values?.['location-info']?.location?.location_id
        ? values?.['location-info']?.location?.location_id
        : values?.['location-info']?.city?.location_id,
      ...platformDetails,
    },
    subject_id: userId,
  };
};

export default { autoGeneratedListingContentPayload, getUpdateListingPayload };
